/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Promotion_Slot_NameInputs */

const en_directory_promotion_slot_name = /** @type {(inputs: Directory_Promotion_Slot_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empty slot`)
};

const zh_directory_promotion_slot_name = /** @type {(inputs: Directory_Promotion_Slot_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`空槽位`)
};

/**
* | output |
* | --- |
* | "Empty slot" |
*
* @param {Directory_Promotion_Slot_NameInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_promotion_slot_name = /** @type {((inputs?: Directory_Promotion_Slot_NameInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Promotion_Slot_NameInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_promotion_slot_name(inputs)
	return zh_directory_promotion_slot_name(inputs)
});
export { directory_promotion_slot_name as "directory.promotion.slot.name" }